import request, { FormDataHeader } from '@/utils/request'
import {
  WuyouPayOrderDetail,
  GetWuyouBuyDetailParams,
  ConfirmWuyouBuyPrams,
  GetWuyouOrderListItem,
  ApplyWuyouOrderInvoiceParams,
  ApplyCommonInvoiceParams,
  GetRepairOrderListItem,
  DeviceJijiaInsuranceInfo,
  GetJijiaInsuranceDeviceListItem,
  ConfirmInsureParams,
  ConfirmBuyJijiaInsuranceResult,
  ClientJijiaInsuranceListItem,
  ClientJijiaInsuranceDetail,
  ServiceChargeListDataItem,
  NameplateReissueBillListItem,
  NameplateReissueBillDetailItem,
  GetInsuranceDetailInfo,
  GetInsuranceRefundInfoResult,
  RequestJijiaInsuranceRefundParams,
  TestDeviceResult,
  TestDeviceFlyListResult,
  ThreeLiabiltyListItem,
  WaitReceiveThreeLiabilityUavItem,
  GetReceiveRuiyunInfo,
  GetApplyInsuranceUserTypeParans,
  RequestBatchCorrectInsuredInfoParams,
} from '@/types/insurance'
import { XssCommonPageListQuery, XssCommonPageListResult } from '@/types/public'
// 获取无忧计划服务信息
export function getWuyouBuyDetail(params: GetWuyouBuyDetailParams): Promise<WuyouPayOrderDetail> {
  return request.post(`/api-member/equipment/safeguard/get_safeguard_price`, params, {
    headers: FormDataHeader,
  })
}

// 购买无忧计划
export function confirmPayWuyouOrder(params: ConfirmWuyouBuyPrams): Promise<string> {
  return request.post(`/api-member/equipment/safeguard/order`, params, {
    headers: FormDataHeader,
  })
}

// 获取无忧计划列表
export function getWuyouOrderList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<GetWuyouOrderListItem>> {
  return request.get(`/api/applets/safeguard/order`, { params })
}

// 无忧计划申请发票
export function confirmWuyouOrderApplyInvoice(
  guid: string,
  params: ApplyWuyouOrderInvoiceParams
): Promise<void> {
  return request.post(`/api/applets/safeguard/order/${guid}/apply_invoice`, params)
}

// 检查无忧计划支付状态
export function checkWuyouPayOrderStatus(order_no: string): Promise<{ is_pay: boolean }> {
  return request.get(`/api-member/equipment/safeguard/checkPay`, { params: { order_no } })
}

// 获取维修订单列表
export function getRepairOrderList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<GetRepairOrderListItem>> {
  return request.get(`/api/applets/repair/invoice`, { params })
}
// 维修单据申请发票
export function confirmRepairOrderApplyInvoice(
  guid: string,
  params: ApplyCommonInvoiceParams
): Promise<void> {
  return request.post(`/api/applets/repair/${guid}/invoice`, params)
}

// 安心保-设备选择
export function getJijiaInsuranceDeviceList(): Promise<GetJijiaInsuranceDeviceListItem[]> {
  return request.get('/api/applets/common/equipments/insurance_equipment_list')
}

// 获取设备投保方案
export function getDeviceInsuranceInfo(sn: string): Promise<DeviceJijiaInsuranceInfo[]> {
  return request.get(`/api/applets/insurance/get_device_product_list?sn=${sn}`)
}

//安心保验机
export function getDeviceTestInfo(sn: string): Promise<TestDeviceResult> {
  return request.get(`/api/applets/insurance/test_device?sn=${sn}`)
}

// 获取验机架次
export function getDeviceFlyCheckInfo(id: string): Promise<TestDeviceFlyListResult> {
  return request.get(`/api/applets/insurance/get_fly_check?id=${id}`)
}

// 确认投保
export function confirmBuyJijiaInsurance(
  params: ConfirmInsureParams
): Promise<ConfirmBuyJijiaInsuranceResult> {
  return request.post('/api/applets/insurance/insure', params)
}
// 发送短信验证码
export function sendSmsVerifyCode(params: { policy_no: string }): Promise<void> {
  return request.post('/api/applets/insurance/send_code', params)
}
// 获取当前退保所需保单信息以及当前帐号电话
export function getInsuranceRefundInfo(params: {
  sn: string
}): Promise<GetInsuranceRefundInfoResult> {
  return request.get('/api/applets/insurance/get_waive_policy_info', { params })
}
// 获取机身险列表
export function getClientJijiaInsuranceList(
  params: XssCommonPageListQuery & { eq_sn: string }
): Promise<XssCommonPageListResult<ClientJijiaInsuranceListItem>> {
  // 获取用户平安机身险列表
  return request.get('/api/applets/insurance/pingan_list', { params })
}

// 获取机身险详情

export function getClientJijiaInsuranceDetail(params: {
  policy_no?: string
  eq_sn?: string
  id?: string
}): Promise<ClientJijiaInsuranceDetail> {
  return request.get('/api/applets/insurance/pingan_info', { params })
}

// 获取飞机激活信息
export function getDeviceActiveInfo(key: string): Promise<{
  gift: Array<{
    color: null
    event_type: string
    icon: string
    message: string
    numerical_value: string
    success: boolean
    type: null
  }>
}> {
  return request.get('/api/applets/insurance/get_activate_params?key=' + key)
}

// 获取退保预报价
export function getJijiaOrderRefundPrice(policy_no: string): Promise<{
  policy_no: string //保单号
  actual_premium_change: string //预报价
}> {
  return request.get('/api/applets/insurance/get_pre_quotation?policy_no=' + policy_no)
}

// 保单退保（见费、非见费）
export function requestJijiaInsuranceRefund(
  params: RequestJijiaInsuranceRefundParams
): Promise<void> {
  return request.post('/api/applets/insurance/back_insured', params)
}

// 撤销未支付订单
export function cancelWaitPayJijiaInsuranceOrder(apply_policy_no: string): Promise<void> {
  return request.post('/api/applets/insurance/cancel_apply?apply_policy_no=' + apply_policy_no)
}

// 服务费用订单发票列表
export function getServiceChargeList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<ServiceChargeListDataItem>> {
  return request.get('/api/applets/after_sales_order/invoice_list', { params })
}

// 服务费用单据申请发票
export function confirmServiceChargeOrderApplyInvoice(
  guid: string,
  params: ApplyCommonInvoiceParams
): Promise<void> {
  return request.post(`/api/applets/after_sales_order/${guid}/apply_invoice`, params)
}

// 获取电子保单资源地址
export function getDownloadPolicyUrl(policy_no: string): Promise<{
  url: string
}> {
  return request.get(`/api/applets/insurance/get_print_policy?policy_no=${policy_no}`)
}

// 查看发票详情信息
export function getInsuranceDetailInfo(guid: string): Promise<GetInsuranceDetailInfo> {
  return request.get(`/api/applets/invoice/invoice_info?guid=${guid}`)
}

// 铭牌三证发票列表
export function getNameplateReissueBillList(
  params: XssCommonPageListQuery
): Promise<XssCommonPageListResult<NameplateReissueBillListItem>> {
  return request.get(`/api/applets/nameplate/invoice_list`, { params })
}

// 铭牌三证发票详情
export function getNameplateReissueBillDetail(
  guid: string
): Promise<Array<NameplateReissueBillDetailItem>> {
  return request.get(`/api/applets/nameplate/details/${guid}`)
}

// 铭牌三证发票申请
export function confirmNameplateReissueOrderApplyInvoice(
  guid: string,
  params: ApplyCommonInvoiceParams
): Promise<void> {
  return request.post(`/api/applets/nameplate/apply_invoice/${guid}`, params)
}

// 查询是否有优惠券
export function getUserInsuranceCouponInfo(params: {
  sn: string
}): Promise<{ is_exist_equity: boolean }> {
  return request.get('/api/applets/insurance/get_equity_tip', { params })
}

// 获取三责险列表
export function getThreeLiabilityList(params?: {
  limit?: number
  user_guid: string
}): Promise<ThreeLiabiltyListItem[]> {
  return request.get('/api-v3/insurance/policy/policyList', { params })
}

// 获取待投保飞机
export function getWaitReceiveThreeLiabilityUav(params?: {
  user_guid: string
}): Promise<WaitReceiveThreeLiabilityUavItem[]> {
  return request.get('/api-v3/insurance/policy/waitPolicyList', { params })
}
// 查询吊运设备领取三责险信息
export function getSnCanReceiveRuiyunInfo(params: { sn: string }): Promise<GetReceiveRuiyunInfo> {
  return request.post('/api-v3/insurance/policy/getIsRuiYunCodeBySnIs', params, {
    headers: FormDataHeader,
  })
}
// 吊运设备的睿运的保单信息与当前人关联
export function requestContactSnAndThreeLiabilityInsurance(params: {
  sn: string
  policy_guid: string
}): Promise<void> {
  return request.post('/api-v3/insurance/policy/setRunYunPolicyToUser', params, {
    headers: FormDataHeader,
  })
}
// 判断当前投保人是否为优质客户
export function getApplyInsuranceUserType(params: GetApplyInsuranceUserTypeParans): Promise<{
  is_exist_quality: boolean
}> {
  return request.post('/api/applets/insurance/get_high_quality_customers', params)
}

// 批量批改被保人信息（单笔/批量通用）
export function requestBatchCorrectInsuredInfo(
  params: RequestBatchCorrectInsuredInfoParams
): Promise<void> {
  return request.post('/api/applets/insurance/batch_correct_insured', params)
}
